export default "__VITE_ASSET__c0b1VSp3__"